// require('dotenv').config()
import { createStore, combineReducers, compose, applyMiddleware } from 'redux'
import { routerMiddleware } from 'react-router-redux'
import persistState from 'redux-localstorage'
import thunk from 'redux-thunk'
import { createBrowserHistory } from 'history'
import request from 'superagent'
import prefix from 'superagent-prefix'
import jwtDecode from 'jwt-decode'
import moment from 'moment'
import { camelCase } from 'lodash'

// import authentication from '../reducers/authentication'

// REDUCERS
import { routerReducer } from 'react-router-redux'
// import { messagingProps } from '../reducers/message-drawer'
// import { drawer } from '../reducers/drawer'

let reducers = {}
let defaults = {}

const reducersReq = require.context('../reducers', true, /^(.*\.(js$))[^.]*$/im)

reducersReq.keys().forEach(key => {
  const reducerName = camelCase(key.match(/.\/([\w-]+).js/)[1])
  reducers[reducerName] = reducersReq(key).default
  defaults[reducerName] = reducersReq(key)[`${reducerName}ReducerDefaultState`]
  // console.log(reducers)
})

export const API = request
  .agent()
  .use(
    prefix(
      `${process.env.REACT_APP_URL}/${
      process.env.REACT_APP_ENV || 'dev'
      }`
    )
  )

export const AUTH = request
  .agent()
  .use(
    prefix(
      `${process.env.REACT_APP_URL}/${
      process.env.REACT_APP_ENV || 'dev'
      }`
    )
  )

export const history = createBrowserHistory()

const initialState = {}
const enhancers = []
const middleware = [thunk, routerMiddleware(history)]

enhancers.push(
  persistState(null, {
    key: 'SafeShowing', //changed from ADESK
    slicer: paths => {
      return state => {
        // let isSuperAdmin = defaults.authentication.isSuperAdmin
        // if (state.authentication.token) {
        //   const decodedToken = jwtDecode(state.authentication.token)
        //   if (decodedToken.companies === '*') {
        //     isSuperAdmin = true
        //   }
        // }
        return {
          authentication: {
            ...defaults.authentication,
            authenticatedUser: state.authentication.authenticatedUser,
            token: state.authentication.token
            // isSuperAdmin
          },
          users: state.users
        }
      }
    },
    merge: (initialState, persistedState) => {
      if (persistedState && persistedState.authentication.token) {
        // console.log('initial', initialState)
        // console.log('persisted', persistedState)
        // decode the token
        const decodedToken = jwtDecode(persistedState.authentication.token)
        // console.log('decodedToken', decodedToken)
        // get the expiration as a moment
        const expDate = moment.unix(decodedToken.exp)
        // get today as a moment
        // console.log('expDate', expDate)
        const nowDate = moment()
        // get the difference in hours
        // console.log('nowDate', nowDate)
        const differenceInHours = nowDate.diff(expDate, 'hours', true)
        // if the difference is greater than an hour throw our the loaded state to force a login
        // console.log('differenceHours', differenceInHours)

        if (differenceInHours > 1) {
          // ! Backend is setting exp at 8 hours
          persistedState = {}
        } else {
          // otherwise allow the loaded state to be hydrated
          API.set('Authorization', persistedState.authentication.token)
          AUTH.set('Authorization', persistedState.authentication.token)
        }
      }

      return persistedState
        ? { ...initialState, ...persistedState }
        : initialState
    }
  })
)

// HOWs this work?
if (process.env.NODE_ENV === 'development') {
  const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__

  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension())
  }
}

// container for middleware
const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers
)

const store = createStore(
  combineReducers({
    routing: routerReducer,
    ...reducers
  }),
  initialState,
  composedEnhancers
)

export default store
